module.exports = __webpack_public_path__ + "media/src/public/img/text-card-image-1ef8a5d35d93417c0f6d9301621adfc4.webp";